import { createSelector } from "reselect"
import { mapValues } from "lodash"

const rawEntitiesSelector = state => state.entities

/**
 * Generic cached-entity bag: any settings-file can read `entities.<name>` for a
 * dashboard-specific resource loaded via loadAllEntities, without this shared
 * container needing to know that name.
 *
 * Memoized off `state.entities` so the returned object keeps a stable reference
 * across renders where the underlying entities haven't changed, which is required
 * for `memoize-one` consumers (e.g. CustomDashboard's `memoizedGetSettings`) to
 * actually skip recomputation instead of busting on a fresh object every call.
 */
export const entitiesSelector = createSelector(rawEntitiesSelector, entities => mapValues(entities, entity => Object.values(entity?.objects ?? {})))
